import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "components/Marketing/marketing.scss";
import { getMarketing } from "services/get-getMarketing";
import { ResponseObject } from "atoms/models";

const Marketing = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const WINDOW_LOCATION = "ec:windowLocation";

  useEffect(() => {
    const getMarketingLink = async () => {
      const response: ResponseObject = await getMarketing();
      if (response?.["_links"]?.[WINDOW_LOCATION]?.href) {
        const SSOlink = response["_links"][WINDOW_LOCATION].href;

        // Check auth token AFTER SSOLink is updated
        checkAuthToken(SSOlink);
      }
    };

    const fetchUrlParams = () => {
      if (!window.location.hash && searchParams.get("item") && searchParams.get("type")) {
        const item = searchParams.get("item");
        const type = searchParams.get("type");
        const utm_content = searchParams.get("utm_content");
        const utm_medium = searchParams.get("utm_medium");
        const utm_source = searchParams.get("utm_source");
        const utm_campaign = searchParams.get("utm_campaign");

        if (item && type) {
          sessionStorage.setItem("item", item);
          sessionStorage.setItem("type", type);
        }
        if (utm_content && utm_medium && utm_source && utm_campaign) {
          sessionStorage.setItem(
            "utmInfo",
            JSON.stringify({
              content: utm_content,
              medium: utm_medium,
              source: utm_source,
              campaign: utm_campaign,
            })
          );
        }
      }
    };

    const checkAuthToken = (SSOlink: string) => {
      const authToken = localStorage.getItem("msAuthToken");
      if (!authToken) {
        window.location.href = SSOlink;
      } else {
        navigate(`/auth#id_token=${encodeURIComponent(authToken)}`);
      }
    };

    getMarketingLink();
    fetchUrlParams();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="marketing-container">
      <div className="d-flex">
        <h3>Redirecting you</h3>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Marketing;
